(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/wager/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/tur/wager/assets/javascripts/init.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs = svs || {};
(svs => {
  svs.components.Storage.browser.remove('wagerstart', 'Wager');
  svs.tur.wager = svs.tur.wager || {};
  svs.tur.wager.CONSTANTS = svs.tur.wager.CONSTANTS || {};
  svs.tur.wager.logger = svs.tur.wager.logger || new svs.core.log.Logger('tur:wager');
  svs.tur.wager.CONSTANTS = _objectSpread(_objectSpread({}, svs.tur.wager.CONSTANTS), {}, {
    productName: {
      ELOTTO: 'Eurojackpot',
      VOUCHER: 'Värdekod',
      TRISS: 'Triss',
      LORLOTTO: 'Lotto Lördag',
      ONSLOTTO: 'Lotto Onsdag',
      KENO: 'Keno',
      VIKING: 'Vikinglotto',
      ONSJOKER: 'Joker Onsdag',
      LORJOKER: 'Joker Lördag',
      KENOXPRESS: 'KenoXpress'
    }
  });
  svs.tur.wager.CONSTANTS = _objectSpread(_objectSpread({}, svs.tur.wager.CONSTANTS), {}, {
    simpleProductName: {
      ELOTTO: 'Eurojackpot',
      VOUCHER: 'Värdekod',
      TRISS: 'Triss',
      LORLOTTO: 'Lotto',
      ONSLOTTO: 'Lotto',
      KENO: 'Keno',
      VIKING: 'Vikinglotto',
      KENOXPRESS: 'KenoXpress',
      SKRKRY: 'KenoXpress'
    }
  });
})(svs);

 })(window);